import { createContext, useContext, useState } from "react";
import { ProductDetailModal } from "@/components/store/ProductDetailModal";

const ProductModalContext = createContext(null);

export function ProductModalProvider({ children }) {
  const [product, setProduct] = useState(null);
  const [open, setOpen] = useState(false);

  const openProduct = (p) => { setProduct(p); setOpen(true); };

  return (
    <ProductModalContext.Provider value={{ openProduct }}>
      {children}
      <ProductDetailModal product={product} open={open} onClose={() => setOpen(false)} />
    </ProductModalContext.Provider>
  );
}

export const useProductModal = () => useContext(ProductModalContext);
